import { render } from "./EmpleadosAreaTurnoForm-Component.vue?vue&type=template&id=fd002b8c"
import script from "./EmpleadosAreaTurnoForm-Component.vue?vue&type=script&lang=js"
export * from "./EmpleadosAreaTurnoForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__